/**
 * Whether this user may see bulk delete at all (OL-155). The firm can keep it
 * for admins only; the server enforces the same switch. The per-record-type
 * delete permission is still checked by each list (canDelete).
 */
export const bulkDeleteAllowed = (user) => {
  if (!user?.security?.bulk_delete_admins_only) return true;

  const permissions = user?.permissions ?? [];
  const roles = user?.roles ?? [];

  return permissions.includes('is_admin_access') || roles.includes('super-admin');
};
